import { put, call, takeLatest } from "redux-saga/effects";
import * as API from "us.collection.admin/services";
import * as Actions from "us.collection.admin/actions";
import { ClosureCodes } from "us.collection.admin/constants/Actions";
import Common from "us.common";
import _ from "lodash";

const { $MessageBox } = Common.Components;

const { closureCode: closureCodeService, history } = API.closureCode;

const { closureCodes } = Actions;

const { closureCode, newClosureCode, closureCodeHistory, closureCodeDeletion } =
  closureCodes;

const ClosureCodesSagas = {
  closureCode: {
    get: function* (action: any) {
      const params = action?.payload?.data ?? {};
      try {
        const { data, status } = yield call(closureCodeService.get, params);
        yield put(closureCode.success(data));
      } catch (error) {
        yield put(closureCode.fail({}));
      }
    },
    save: function* (action: any) {
      const params = action?.payload?.data ?? {};
      try {
        const { data, status } = yield call(closureCodeService.add, params);
        if (status == 201) {
          const { data: newCloserCodes, status: newCloserCodesStatus } =
            yield call(closureCodeService.get, {});
          yield put(closureCode.success(newCloserCodes));

          yield put(newClosureCode.success(data));
          $MessageBox(
            "success",
            `US.COLLECTION.ADMIN:MANAGE_CLOSURE_CODES.CLOSURE_CODE_ADDED_SUCCESSFULLY`,
            "",
            ""
          );
        } else if (status == 409) {
          yield put(newClosureCode.fail({}));
          $MessageBox(
            "error",
            `US.COLLECTION.ADMIN:MANAGE_CLOSURE_CODES.NAME_IS_ALREADY EXISTS`,
            "",
            ""
          );
        } else {
          yield put(newClosureCode.fail({}));
          $MessageBox(
            "error",
            `US.COLLECTION.ADMIN:MANAGE_CLOSURE_CODES.CLOSURE_CODE_ADD_FAIL`,
            "",
            ""
          );
        }
      } catch (error) {
        yield put(newClosureCode.fail({}));
      }
    },
    update: function* (action: any) {
      const params = action?.payload?.data ?? {};
      try {
        const { data, status } = yield call(closureCodeService.update, params);
        if (status == 201) {
          const { data: newCloserCodes, status: newCloserCodesStatus } =
            yield call(closureCodeService.get, {});
          yield put(closureCode.success(newCloserCodes));

          yield put(newClosureCode.success(data));
          $MessageBox(
            "success",
            `US.COLLECTION.ADMIN:MANAGE_CLOSURE_CODES.CLOSURE_CODE_UPDATE_SUCCESSFULLY`,
            "",
            ""
          );
        } else {
          yield put(newClosureCode.fail({}));
          $MessageBox(
            "error",
            `US.COLLECTION.ADMIN:MANAGE_CLOSURE_CODES.CLOSURE_CODE_UPDATE_FAIL`,
            "",
            ""
          );
        }
      } catch (error) {
        yield put(newClosureCode.fail({}));
      }
    },
    delete: function* (action: any) {
      const params = action?.payload?.data ?? {};
      try {
        const { data, status } = yield call(closureCodeService.delete, params);
        if (status == 200) {
          const { data: newCloserCodes, status: newCloserCodesStatus } =
            yield call(closureCodeService.get, {});
          yield put(closureCode.success(newCloserCodes));

          yield put(closureCodeDeletion.success(data));
          $MessageBox(
            "success",
            `US.COLLECTION.ADMIN:MANAGE_CLOSURE_CODES.CLOSURE_CODE_DELETE_SUCCESSFULLY`,
            "",
            ""
          );
        } else {
          yield put(closureCodeDeletion.fail({}));
          $MessageBox(
            "error",
            `US.COLLECTION.ADMIN:MANAGE_CLOSURE_CODES.CLOSURE_CODE_DELETE_FAIL`,
            "",
            ""
          );
        }
      } catch (error) {
        yield put(closureCodeDeletion.fail({}));
      }
    },
  },
  history: {
    get: function* (action: any) {
      const params = action?.payload?.data ?? {};
      try {
        const { data, status } = yield call(history.get, params);
        if (status == 200) {
          yield put(closureCodeHistory.success(data));
        } else {
          yield put(closureCodeHistory.fail({}));
        }
      } catch (error) {
        yield put(closureCodeHistory.fail({}));
      }
    },
  },
};

export default [
  takeLatest(ClosureCodes.GET_CLOSURE_CODES, 
    ClosureCodesSagas.closureCode.get
  ),
  takeLatest(
    ClosureCodes.ADD_CLOSURE_CODES,
    ClosureCodesSagas.closureCode.save
  ),
  takeLatest(
    ClosureCodes.UPDATE_CLOSURE_CODES,
    ClosureCodesSagas.closureCode.update
  ),
  takeLatest(
    ClosureCodes.GET_CLOSURE_CODE_HISTORY,
    ClosureCodesSagas.history.get
  ),
  takeLatest(
    ClosureCodes.DELETE_CLOSURE_CODE,
    ClosureCodesSagas.closureCode.delete
  ),
];
